exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.max-width[data-v-4c917d6f] {\n\tmax-width: 20%;\n}\n", ""]);

// exports
